import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, rpcCrudService } from "kea-resource";
import { CampoRepetidoIdentificacion, ResourceIdentificacionRepetido } from "./identificacion";

const controller = rpcController("Factura");
const crud = rpcCrudService<models.Factura, models.FacturaDto>(controller);

const otros = {
    /**Cancela una factura */
    CancelarFactura: async (model: models.CancelarFacturaModel): Promise<void> => await controller('CancelarFactura', {}, model),
    GenerarPagoAFactura: async (abono: models.AbonoPago): Promise<void> => await controller('GenerarPagoAFactura', {}, abono),

    /**Obtiene todas las entidades filtradas por la zona */
    Query: async (filtro: models.FiltroFacturas): Promise<models.FacturaDto[]> => await controller('Query', {}, filtro),

    /**
    * Timbrar una factura
    */
    TimbrarFactura: async (id: number): Promise<void> => await controller("TimbrarFactura", { id }),

    /**
     * Timbrar una factura a partir de su Id y en caso de que se produzca una exception al timbrar regresa el error si no regresa null
     */
    TimbrarFacturaMensajeException: async (id: number): Promise<string> => await controller("TimbrarFacturaMensajeException", { id }),

    /**
    * Genera una nota de credito a partir de una factura y regresa el id de la nueva factura creada
    */
    GenerarNotaCredito: async (idFactura: number): Promise<number> => await controller("GenerarNotaCredito", { idFactura }),

    CorregirFacturaCobranza: async (idFactura: number): Promise<number> => await controller("CorregirFacturaCobranza", { idFactura }),

    /**
 * Contabiliza una factura
 * @param idFactura 
 */
    ContabilizarFactura: async (idFactura: number): Promise<void> => await controller('ContabilizarFactura', { idFactura }),


    ObtenerXML: async (id: number): Promise<string> => await controller("ObtenerXML", { id }),

    ObtenerPDF: async (id: number): Promise<string> => await controller("ObtenerPDF", { id }),

    /**Obtiene el reporte de la factura sin timbrar */
    GetReporteContrarecibo: async (idFactura: number): Promise<string> => await controller("GetReporteContrarecibo", { idFactura }),

    /**Obtiene el reporte de detalle de factura para cobranza */
    ObtenerReporteDetalleCobranza: async (idFactura: number): Promise<string> => await controller("GetReporteDetalleCobranza", { idFactura }),

    /**
     * Duplica una factura existente, agrega la entidad y devuelve la nueva entidad. El folio es recalculado, ni el timbre, fecha de creación, relación con los contrarecibos de cobranza se duplica.
     * Devuelve el Id de la nueva factura
     */
    DuplicarFactura: async (idFactura: number): Promise<number> => await controller('DuplicarFactura', { idFactura }),
    /**Regenera la poliza  contable de una factura Si es que esta cancelada */
    GenerarPolizaCancelacion: async (idFactura: number): Promise<void> => await controller('GenerarPolizaCancelacion', { idFactura }),

    /**Envía una factura por correo a una dirección de correo especifica */
    EnviarCorreo: async (idFactura: number, correoDestino: string): Promise<boolean> => await controller('EnviarCorreo', { idFactura, correoDestino }),

    /**Cambiar el tipo de persona de una factura recalculando sus impuestos */
    CambiarTipoPersona: async (idFactura: number, tipo: models.TipoPersona): Promise<boolean> => await controller("CambiarTipoPersona", { idFactura, tipo }),

    /**Actualiza las banderas especiales de cobranza de una factura, sin verificar si esta o no timbrada */
    ActualizarBanderasCobranza: async (entity: models.Factura): Promise<void> => await controller("ActualizarBanderasCobranza", {}, entity),

    /**Regresa la clave SAT de moneda para facturas manuales que está registrada en la configuración */
    DatosInicioFactura: async (): Promise<models.DatosInicioFactura> => await controller("DatosInicioFactura"),

    /**Convierte una factura de crédito en manual */
    ConvertirFacturaEnManual: async (idFactura: number): Promise<models.DatosInicioFactura> => await controller("ConvertirFacturaEnManual", { idFactura }),

    /**Cancela un conjunto de facturas */
    CancelarMultipleFacturas: async (idFacturas: number[]): Promise<void> => await controller("CancelarMultipleFacturas", { idFacturas }),

    /**Cancela un grupo de facturas especificas */
    CancelarFacturasEspecificas: async (): Promise<void> => await controller("CancelarFacturasEspecificas"),

    //metodos de carta porte
    TimbrarCartaPorteViajeRuta: async (id: number): Promise<string> => await controller('TimbrarCartaPorteViajeRuta', { idViajeRuta: id}),

    ImprimirPdfViajeRuta: async (id: number): Promise<string> => await controller('ImprimirPdfViajeRuta', { idViajeRuta: id}),


    TimbrarCartaPorteEAD: async (id: number): Promise<string> => await controller('TimbrarCartaPorteEAD', { idEAD: id}),

    ImprimirPdfEAD: async (id: number): Promise<string> => await controller('ImprimirPdfEAD', { idViajeEAD: id}),
    

    ImprimirPdfEadPorCliente: async (idEad: number, idCliente: number): Promise<string> => 
    await controller('ImprimirPdfEADporCliente', { idViajeEAD: idEad, idCliente: idCliente }),

    descargarXmlViajeEadPorCliente: async (idEad: number, idCliente: number): Promise<string> => 
    await controller('descargarXmlViajeEadporCliente', { idViajeEAD: idEad, idCliente: idCliente }),


    TimbrarCartaPorteRAD: async (id: number): Promise<string> => await controller('TimbrarCartaPorteRAD', { idRAD: id}),

    ImprimirPdfRAD: async (id: number): Promise<string> => await controller('ImprimirPdfCartaPorteRAD', { idRAD: id}),


    TimbrarCartaPorteZE: async (id: number): Promise<string> => await controller('TimbrarCartaPorteZE', { idViajeZE: id}),

    ImprimirPdfZE: async (id: number): Promise<string> => await controller('ImprimirPdfZE', { idViajeZE: id}),


    /**Cancela un conjunto de facturas */
    CancelarFacturaPaquetePP: async (idFacturas: number[], idPaquetePP: number): Promise<void> => await controller("CancelarFacturaPaquetePP", { idFacturas, idPaquetePP }),


}

export const Factura = cacheResource({
    ...crud,
    ...otros
}, {
        get: true,
        Query: true,
        DatosInicioFactura: true
    }, {
        CancelarFactura: true,
        TimbrarFactura: true,
        GenerarNotaCredito: true,
        DuplicarFactura: true,
        GenerarPagoAFactura: true,
        ActualizarBanderasCobranza: true,
        TimbrarCartaPorteViajeRuta:true,
        ImprimirPdfViajeRuta:true,

        TimbrarCartaPorteEAD: true,
        ImprimirPdfEAD: true,

        TimbrarCartaPorteRAD:true,
        ImprimirPdfRAD:true,
    })


// WEBPACK FOOTER //
// ./app/resources/items/factura.tsx